webpackJsonp([1],{

/***/ 103:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    status: {
      type: String,
      required: true
    },
    msg: {
      type: String,
      default: ""
    }
  },
  computed: {
    message: function message() {
      return this.msg ? this.msg : this.status;
    }
  }
});

/***/ }),

/***/ 104:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_lib__ = __webpack_require__(105);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    history: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    regId: {
      type: String,
      default: ""
    }
  },
  computed: {
    historyFlat: function historyFlat() {
      var entries = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(this.history);
      entries.sort(function (a, b) {
        var dateA = Object(__WEBPACK_IMPORTED_MODULE_1__assets_lib__["b" /* toDefaultDate */])(a.dateTime);
        var dateB = Object(__WEBPACK_IMPORTED_MODULE_1__assets_lib__["b" /* toDefaultDate */])(b.dateTime);
        return dateA - dateB;
      });
      return entries;
    }
  },
  methods: {
    statusCode: function statusCode(status) {
      var successList = ["success", "initiated", "scheduled", "triggered"];

      if (successList.includes(status)) return "success";
      return status;
    },
    month: function month(date) {
      return Object(__WEBPACK_IMPORTED_MODULE_1__assets_lib__["a" /* monthFromDate */])(date);
    },
    tooltip: function tooltip(entry) {
      var tip = "";
      if (entry.status) tip += entry.status;
      if (entry.info) tip += " | " + entry.info;
      if (entry.trnId) tip += " | " + entry.trnId;

      return tip;
    },
    handleClick: function handleClick(entry) {
      this.$emit("click", this.regId, entry.trnId, entry.dateTime);
    }
  }
});

/***/ }),

/***/ 105:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = monthFromDate;
/* harmony export (immutable) */ __webpack_exports__["b"] = toDefaultDate;
function monthFromDate(date) {
  var key = date && date.split('-')[1] || '-';
  var months = {
    '01': 'Jan',
    '02': 'Feb',
    '03': 'Mar',
    '04': 'Apr',
    '05': 'May',
    '06': 'Jun',
    '07': 'Jul',
    '08': 'Aug',
    '09': 'Sep',
    '10': 'Oct',
    '11': 'Nov',
    '12': 'Dec',
    '-': ''
  };
  return months[key];
}

function toDefaultDate(DDMMYYYY) {
  var split = DDMMYYYY.split('-'); // 05-03-2020
  var day = split[0];
  var month = split[1] - 1;
  var year = split[2];

  return new Date(year, month, day);
}

/***/ }),

/***/ 141:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_marked__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_marked___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_marked__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      dialog: false,

      headers: [{
        text: "ID",
        value: "id",
        align: "left"
      }, {
        text: "Title",
        value: "title",
        align: "left"
      }, {
        text: "Subheading",
        value: "subheading",
        align: "left"
      }, {
        text: "Active?",
        value: "active"
      }, {
        text: "Featured?",
        value: "featured"
      }, { text: "Actions", value: "name", sortable: false }],
      editedIndex: -1,
      editedItem: {
        id: "unique-project-id",
        title: "Sample title",
        subheading: "",
        intro: "",
        description: "",
        active: true,
        featured: true,
        solutionId: 0
      },
      defaultItem: {
        id: "005",
        title: "",
        subheading: "",
        intro: "",
        description: "# Heading1 \n## Heading 2 \n### Heading 3 \nParagraph 1\nParagraph 2\n- list item1 \n- list item",
        active: true,
        featured: true,
        solutionId: 0
      },

      items: [{ label: "Care Giving", key: 1 }, { label: "Health Care", key: 2 }, { label: "Education", key: 3 }, { label: "Infrastructure", key: 4 }, { label: "Aftercare", key: 5 }],

      rules: {
        required: function required(value) {
          return !!value || "Required.";
        }
      },

      editorConfigs: {
        hideIcons: ["image"],
        toolbarTips: true,
        styleSelectedText: false
      }
    };
  },

  computed: {
    programList: function programList() {
      return this.$store.getters.programList;
    },
    formTitle: function formTitle() {
      return this.editedIndex === -1 ? "Add a new Program" : "Edit a Program";
    },
    markdown: function markdown() {
      return __WEBPACK_IMPORTED_MODULE_1_marked___default()(this.editedItem.description, { sanitize: true });
    }
  },

  watch: {
    dialog: function dialog(val) {
      val || this.close();
    }
  },

  mounted: function mounted() {
    this.editedItem = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.defaultItem);
    this.editedIndex = -1;
  },


  methods: {
    editItem: function editItem(item) {
      this.editedIndex = this.programList.indexOf(item);
      this.editedItem = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, item);
      this.dialog = true;
    },
    deleteItem: function deleteItem(item) {
      confirm("Are you sure you want to delete this item?") && this.$store.dispatch("deleteProgram", item);
    },
    close: function close() {
      var _this = this;

      this.dialog = false;
      setTimeout(function () {
        _this.editedItem = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _this.defaultItem);
        _this.editedIndex = -1;
      }, 300);
    },
    save: function save() {
      if (this.editedIndex > -1) {
        this.$store.dispatch("saveProgram", this.editedItem);
      } else {
        this.$store.dispatch("addProgram", this.editedItem);
      }

      this.close();
    }
  }
});

/***/ }),

/***/ 142:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_marked__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_marked___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_marked__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      dialog: false,
      search: "",
      headers: [{
        text: "Title",
        value: "title",
        align: "left"
      }, {
        text: "Area",
        value: "area",
        align: "left"
      }, {
        text: "Lat",
        value: "lat"
      }, {
        text: "Lng",
        value: "lng"
      }, {
        text: "Covered?",
        value: "covered"
      }, {
        text: "Order",
        value: "order",
        align: "right"
      }, { text: "Actions", value: "name", sortable: false }],
      editedIndex: -1,
      editedItem: {
        key: "unique-location-key",
        title: "Sample title",
        area: "",
        lat: "",
        lng: "",
        covered: false
      },
      defaultItem: {
        key: "unique-location-key",
        title: "Sample title",
        area: "",
        lat: "",
        lng: "",
        covered: false
      },

      rules: {
        required: function required(value) {
          return !!value || "Required.";
        }
      }
    };
  },

  computed: {
    locationList: function locationList() {
      return this.$store.getters.locationList;
    },
    formTitle: function formTitle() {
      return this.editedIndex === -1 ? "Add a new Location" : "Edit a Location";
    }
  },

  watch: {
    dialog: function dialog(val) {
      val || this.close();
    }
  },

  mounted: function mounted() {
    this.editedItem = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.defaultItem);
    this.editedIndex = -1;
  },


  methods: {
    editItem: function editItem(item) {
      this.editedIndex = this.locationList.indexOf(item);
      this.editedItem = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, item);
      this.dialog = true;
    },
    deleteItem: function deleteItem(item) {
      confirm("Are you sure you want to delete this item?") && this.$store.dispatch("deleteLocation", item);
    },
    close: function close() {
      var _this = this;

      this.dialog = false;
      setTimeout(function () {
        _this.editedItem = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _this.defaultItem);
        _this.editedIndex = -1;
      }, 300);
    },
    save: function save() {
      if (this.editedIndex > -1) {
        this.$store.dispatch("saveLocation", this.editedItem);
      } else {
        this.$store.dispatch("addLocation", this.editedItem);
      }

      this.close();
    }
  }
});

/***/ }),

/***/ 143:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      impacts: [],
      rules: {
        required: function required(value) {
          return !!value || "Required.";
        }
      }
    };
  },
  mounted: function mounted() {
    this.impacts = this.$store.getters.impactList;
  },


  methods: {
    save: function save() {
      var formatted = {};
      this.impacts.forEach(function (impact) {
        formatted[impact.id] = impact;
      });

      this.$store.dispatch("saveImpact", formatted);
    }
  }
});

/***/ }),

/***/ 144:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_marked__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_marked___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_marked__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      about: "",
      editorConfigs: {
        hideIcons: ["image"],
        toolbarTips: true,
        styleSelectedText: false
      }
    };
  },


  computed: {
    markdown: function markdown() {
      return __WEBPACK_IMPORTED_MODULE_0_marked___default()(this.about, { sanitize: true });
    }
  },

  mounted: function mounted() {
    this.about = this.$store.getters.about;
  },


  methods: {
    save: function save() {
      this.$store.dispatch("saveAbout", this.about);
    }
  }
});

/***/ }),

/***/ 145:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_marked__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_marked___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_marked__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      dialog: false,

      headers: [{
        text: "Title",
        value: "title",
        align: "left"
      }, {
        text: "Role",
        value: "role",
        align: "left"
      }, {
        text: "Type",
        value: "type"
      }, {
        text: "Active?",
        value: "active"
      }, { text: "Actions", value: "name", sortable: false }],
      types: [{ label: "Paid Job", key: "job" }, { label: "Volunteering", key: "volunteer" }],
      editedIndex: -1,
      editedItem: {
        active: true,
        details: "",
        id: "",
        role: "",
        title: "",
        type: ""
      },
      defaultItem: {
        active: true,
        details: "| Table Key | Table Value | \n| -------- | -------- |\n| Type     | Full Time      | \n| Urgency     | Immediate  | \n\n # Heading1 \n## Heading 2 \n### Heading 3 \nParagraph 1\nParagraph 2\n- list item1 \n- list item",
        id: "",
        role: "",
        title: "",
        type: "job"
      },

      rules: {
        required: function required(value) {
          return !!value || "Required.";
        }
      },

      editorConfigs: {
        hideIcons: ["image"],
        toolbarTips: true,
        styleSelectedText: false
      }
    };
  },

  mounted: function mounted() {
    this.editedItem = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.defaultItem);
    this.editedIndex = -1;
  },


  computed: {
    careerList: function careerList() {
      return this.$store.getters.careerList;
    },
    formTitle: function formTitle() {
      return this.editedIndex === -1 ? "Add a new Career" : "Edit a Career";
    },
    markdown: function markdown() {
      return __WEBPACK_IMPORTED_MODULE_1_marked___default()(this.editedItem.details, { sanitize: true });
    }
  },

  watch: {
    dialog: function dialog(val) {
      val || this.close();
    }
  },

  methods: {
    editItem: function editItem(item) {
      this.editedIndex = this.careerList.indexOf(item);
      this.editedItem = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, item);
      this.dialog = true;
    },
    deleteItem: function deleteItem(item) {
      confirm("Are you sure you want to delete this item?") && this.$store.dispatch("deleteCareer", item);
    },
    close: function close() {
      var _this = this;

      this.dialog = false;
      setTimeout(function () {
        _this.editedItem = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _this.defaultItem);
        _this.editedIndex = -1;
      }, 300);
    },
    save: function save() {
      if (this.editedIndex > -1) {
        this.$store.dispatch("saveCareer", this.editedItem);
      } else {
        this.$store.dispatch("addCareer", this.editedItem);
      }

      this.close();
    }
  }
});

/***/ }),

/***/ 146:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      valid: false,
      password: "",
      passwordRules: [function (v) {
        return !!v || "Password is required";
      }, function (v) {
        return v.length > 4 || "Password must be more than 4 characters";
      }],
      email: "",
      emailRules: [function (v) {
        return !!v || "E-mail is required";
      }, function (v) {
        return (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || "E-mail must be valid"
        );
      }]
    };
  },

  computed: {
    user: function user() {
      return this.$store.getters.user;
    }
  },

  watch: {
    user: function user(stateUser) {
      if (stateUser !== null) {
        this.$router.push("/");
      }
    }
  },

  methods: {
    submit: function submit() {
      if (this.$refs.form.validate()) {
        var user = { email: this.email, password: this.password };
        this.$store.dispatch("signin", user);
        this.valid = false;
      }
    },
    clear: function clear() {
      this.$refs.form.reset();
    }
  }
});

/***/ }),

/***/ 147:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return store; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_app__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase_database__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__user__ = __webpack_require__(426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__programs__ = __webpack_require__(429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__donations__ = __webpack_require__(430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__locations__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__impact__ = __webpack_require__(432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__about__ = __webpack_require__(433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__careers__ = __webpack_require__(434);













__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */].Store({
  state: {
    status: {
      show: false,
      type: 'error',
      message: 'Some message'
    }
  },

  getters: {
    status: function status(state) {
      return state.status;
    }
  },

  mutations: {
    showMessage: function showMessage(state, payload) {
      var defaults = {
        show: true,
        type: 'info'
      };
      state.status = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, defaults, payload);
    },
    hideMessage: function hideMessage(state, payload) {
      state.status = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, state.status, payload);
    }
  },
  actions: {
    showMessage: function showMessage(_ref, payload) {
      var commit = _ref.commit;

      commit('showMessage', payload);
    },
    load: function load(_ref2) {
      var commit = _ref2.commit;

      commit('showMessage', { message: 'Loading data from server...' });

      // Load only data
      __WEBPACK_IMPORTED_MODULE_3_firebase_app___default.a.database().ref('/content').once('value').then(function (snapshot) {
        var allData = snapshot.val();

        // commit('loadDonations', allData.data.donations);
        commit('loadPrograms', allData.programs);
        commit('loadLocations', allData.locations);
        commit('loadImpact', allData.impact);
        commit('loadAbout', allData.about);
        commit('loadCareers', allData.careers);
        commit('hideMessage');
      }).catch(function (error) {
        commit('showMessage', {
          type: 'error',
          message: 'Error loading Content data from server... Try relaoding the page'
        });
        console.log(error);
      });

      // Load & Watch data
      __WEBPACK_IMPORTED_MODULE_3_firebase_app___default.a.database().ref('/data/donations/').on('value', function (snapshot) {
        var allData = snapshot.val();
        commit('loadDonations', allData);
      });
    }
  },

  modules: {
    programs: __WEBPACK_IMPORTED_MODULE_6__programs__["a" /* default */],
    donations: __WEBPACK_IMPORTED_MODULE_7__donations__["a" /* default */],
    Locations: __WEBPACK_IMPORTED_MODULE_8__locations__["a" /* default */],
    impact: __WEBPACK_IMPORTED_MODULE_9__impact__["a" /* default */],
    about: __WEBPACK_IMPORTED_MODULE_10__about__["a" /* default */],
    careers: __WEBPACK_IMPORTED_MODULE_11__careers__["a" /* default */],
    user: __WEBPACK_IMPORTED_MODULE_5__user__["a" /* default */]
  }
});

/***/ }),

/***/ 165:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify__ = __webpack_require__(435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuetify_dist_vuetify_min_css__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuetify_dist_vuetify_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuetify_dist_vuetify_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_firebase_app__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_simplemde__ = __webpack_require__(437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_simplemde___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_simplemde__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_simplemde_dist_simplemde_min_css__ = __webpack_require__(454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_simplemde_dist_simplemde_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_simplemde_dist_simplemde_min_css__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.










__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_vue_simplemde___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vuetify___default.a, {
  theme: {
    // primary: '#04368e',
    primary: '#fcbe08',
    secondary: '#032b72',
    accent: '#fcbe08',
    error: '#f44336',
    warning: '#ffeb3b',
    info: '#2196f3',
    success: '#4caf50'
  }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

/* eslint-disable no-new */
var vm = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_5__store__["a" /* store */],
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] },
  template: '<App/>',

  created: function created() {
    var config = {
      apiKey: 'AIzaSyBsN15mAdA52Lw3MnrBnrAsy7mMagIVBnU',
      authDomain: 'guardians-of-dreams.firebaseapp.com',
      databaseURL: 'https://guardians-of-dreams.firebaseio.com',
      projectId: 'guardians-of-dreams',
      storageBucket: 'guardians-of-dreams.appspot.com',
      messagingSenderId: '956847479003'
    };
    __WEBPACK_IMPORTED_MODULE_6_firebase_app___default.a.initializeApp(config);
  }
});

/***/ }),

/***/ 167:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(86);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f8ac413_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(171);
function injectStyle (ssrContext) {
  __webpack_require__(168)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f8ac413_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 168:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 170:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list',[_vm._l((_vm.items),function(item){return [_c('v-list-tile',{key:item.text,attrs:{"to":item.route}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v(_vm._s(item.icon))])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(item.text))])],1)],1)]})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 171:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"inspire"}},[(_vm.isLogged)?_c('v-navigation-drawer',{attrs:{"clipped":_vm.$vuetify.breakpoint.lgAndUp,"mini-variant":_vm.mini,"width":"250","app":"","fixed":"","dark":""},model:{value:(_vm.drawer),callback:function ($$v) {_vm.drawer=$$v},expression:"drawer"}},[_c('v-list',[_c('v-list-tile',{on:{"click":function($event){$event.stopPropagation();_vm.mini = !_vm.mini}}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("MENU")])],1),_vm._v(" "),_c('v-list-tile-action',[_c('v-tooltip',{attrs:{"bottom":""}},[_c('span',{attrs:{"slot":"activator"},slot:"activator"},[(_vm.mini)?_c('v-icon',[_vm._v("chevron_right")]):_c('v-icon',[_vm._v("chevron_left")])],1),_vm._v(" "),_c('span',[_vm._v("Toggle Mini Menu")])])],1)],1),_vm._v(" "),_c('sections-list')],1)],1):_vm._e(),_vm._v(" "),_c('v-toolbar',{attrs:{"clipped-left":_vm.$vuetify.breakpoint.lgAndUp,"color":"blue darken-3","dark":"","app":"","fixed":""}},[_c('v-toolbar-title',{staticClass:"ml-0"},[(_vm.isLogged)?_c('v-toolbar-side-icon',{on:{"click":function($event){$event.stopPropagation();_vm.drawer = !_vm.drawer}}}):_vm._e(),_vm._v(" "),_c('span',{},[_vm._v("Admin Guardian")])],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(_vm.isLogged)?_c('div',[_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){return _vm.handleSignout()}}},[_c('v-icon',[_vm._v("exit_to_app")])],1)],1):_vm._e()],1),_vm._v(" "),_c('v-content',[_c('v-container',{attrs:{"fluid":"","fill-height":"","align-start":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('v-snackbar',{attrs:{"absolute":"","bottom":"","multi-line":"","color":_vm.status.type},model:{value:(_vm.status.show),callback:function ($$v) {_vm.$set(_vm.status, "show", $$v)},expression:"status.show"}},[_vm._v(_vm._s(_vm.status.message))]),_vm._v(" "),_c('router-view')],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 172:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_DashboardPage__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_DonationsPage__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_ProgramsPage__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_LocationsPage__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_ImpactPage__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_AboutPage__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_CareersPage__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_SignInPage__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__auth_guard__ = __webpack_require__(352);













__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/signin',
    name: 'signin',
    component: __WEBPACK_IMPORTED_MODULE_9__pages_SignInPage__["a" /* default */]
  }, {
    path: '/',
    name: 'dashboard',
    component: __WEBPACK_IMPORTED_MODULE_2__pages_DashboardPage__["a" /* default */],
    beforeEnter: __WEBPACK_IMPORTED_MODULE_10__auth_guard__["a" /* default */]
  }, {
    path: '/donations',
    name: 'DonationsPage',
    component: __WEBPACK_IMPORTED_MODULE_3__pages_DonationsPage__["a" /* default */],
    beforeEnter: __WEBPACK_IMPORTED_MODULE_10__auth_guard__["a" /* default */]
  }, {
    path: '/programs',
    name: 'ProgramsPage',
    component: __WEBPACK_IMPORTED_MODULE_4__pages_ProgramsPage__["a" /* default */],
    beforeEnter: __WEBPACK_IMPORTED_MODULE_10__auth_guard__["a" /* default */]
  }, {
    path: '/locations',
    name: 'LocationsPage',
    component: __WEBPACK_IMPORTED_MODULE_5__pages_LocationsPage__["a" /* default */],
    beforeEnter: __WEBPACK_IMPORTED_MODULE_10__auth_guard__["a" /* default */]
  }, {
    path: '/impact',
    name: 'ImpactPage',
    component: __WEBPACK_IMPORTED_MODULE_6__pages_ImpactPage__["a" /* default */],
    beforeEnter: __WEBPACK_IMPORTED_MODULE_10__auth_guard__["a" /* default */]
  }, {
    path: '/about',
    name: 'AboutPage',
    component: __WEBPACK_IMPORTED_MODULE_7__pages_AboutPage__["a" /* default */],
    beforeEnter: __WEBPACK_IMPORTED_MODULE_10__auth_guard__["a" /* default */]
  }, {
    path: '/careers',
    name: 'CareersPage',
    component: __WEBPACK_IMPORTED_MODULE_8__pages_CareersPage__["a" /* default */],
    beforeEnter: __WEBPACK_IMPORTED_MODULE_10__auth_guard__["a" /* default */]
  }, {
    path: '*',
    name: '404',
    redirect: '/'
  }]
}));

/***/ }),

/***/ 174:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DashboardPage_vue__ = __webpack_require__(89);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_234d723c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DashboardPage_vue__ = __webpack_require__(176);
function injectStyle (ssrContext) {
  __webpack_require__(175)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DashboardPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_234d723c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DashboardPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 175:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 176:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"outer dashboard-page"},[_c('span',{staticClass:"display-1"},[_vm._v("Hello Admin!")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticClass:"subtitle"},[_vm._v("Where you want to go?")]),_vm._v(" "),_c('sections-list')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 177:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DonationsPage_vue__ = __webpack_require__(90);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f4fb416_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DonationsPage_vue__ = __webpack_require__(334);
function injectStyle (ssrContext) {
  __webpack_require__(178)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DonationsPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f4fb416_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DonationsPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 178:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 224:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_status_vue__ = __webpack_require__(103);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09826023_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_status_vue__ = __webpack_require__(225);
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_status_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09826023_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_status_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 225:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.status === 'success')?_c('v-chip',{attrs:{"color":"#6CD9D1","text-color":"white"}},[_vm._v(_vm._s(_vm.message))]):_vm._e(),_vm._v(" "),(_vm.status === 'failed')?_c('v-chip',{attrs:{"color":"#E84314","text-color":"white"}},[_c('v-avatar',[_c('v-icon',[_vm._v("error_outline")])],1),_vm._v(_vm._s(_vm.message)+"\n  ")],1):_vm._e(),_vm._v(" "),(_vm.status === 'error')?_c('v-chip',{attrs:{"color":"#E84314","text-color":"white"}},[_vm._v("\n    "+_vm._s(_vm.message)+"\n  ")]):_vm._e(),_vm._v(" "),(_vm.status === 'initiated')?_c('v-chip',{attrs:{"color":"#82BDD9","text-color":"white"}},[_vm._v(_vm._s(_vm.message))]):_vm._e(),_vm._v(" "),(_vm.status === 'scheduled')?_c('v-chip',{attrs:{"color":"#C6C71F","text-color":"white"}},[_c('v-avatar',[_c('v-icon',[_vm._v("done")])],1),_vm._v(_vm._s(_vm.message)+"\n  ")],1):_vm._e(),_vm._v(" "),(_vm.status === 'triggered')?_c('v-chip',{attrs:{"color":"#95C124","text-color":"white"}},[_c('v-avatar',[_c('v-icon',[_vm._v("check_circle_outline")])],1),_vm._v("\n    "+_vm._s(_vm.message)+"\n  ")],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 226:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_history_vue__ = __webpack_require__(104);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79ccff90_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_history_vue__ = __webpack_require__(228);
function injectStyle (ssrContext) {
  __webpack_require__(227)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_history_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79ccff90_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_history_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 227:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 228:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"history"},[_c('div',{staticClass:"data"},[_vm._l((_vm.historyFlat),function(entry,index){return [_c('button',{key:index,staticClass:"entry",class:_vm.statusCode(entry.status),attrs:{"title":_vm.tooltip(entry),"disabled":!entry.dateTime},on:{"click":function($event){return _vm.handleClick(entry)}}},[_vm._v(_vm._s(_vm.month(entry.dateTime)))])]})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 334:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"outer donation-page"},[_c('v-card',{attrs:{"height":"100%"}},[_c('v-card-title',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"title",attrs:{"xs4":"","align-center":""}},[_vm._v("\n          Paynimo Donations\n        ")]),_vm._v(" "),_c('v-flex',{staticClass:"filter",attrs:{"xs4":""}},[_c('v-select',{attrs:{"items":_vm.statusList,"label":"Filter"},model:{value:(_vm.selectedStatus),callback:function ($$v) {_vm.selectedStatus=$$v},expression:"selectedStatus"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-text-field',{attrs:{"append-icon":"search","label":"Search","single-line":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1)],1)],1),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.donationList,"search":_vm.search,"pagination":_vm.pagination,"item-key":"key","rows-per-page-items":[10, 25, 50, 100]},on:{"update:pagination":function($event){_vm.pagination=$event}},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('tr',{on:{"click":function($event){return _vm.setActiveItem(props.item)}}},[_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.donorId))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.UMRN))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left name"},[_vm._v(_vm._s(props.item.name))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left no-wrap"},[_vm._v(_vm._s(props.item.dateStart))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left no-wrap"},[_vm._v(_vm._s(props.item.dateEnd))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(props.item.slot))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(props.item.amount))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_c('status',{attrs:{"status":_vm.getLastStatus(props.item),"msg":_vm.msg(props.item)}})],1)])]}}])},[_vm._v(" "),_c('template',{slot:"no-data "},[_vm._v("Loading Data...")]),_vm._v(" "),_c('v-alert',{attrs:{"slot":"no-results","value":true,"color":"error","icon":"warning"},slot:"no-results"},[_vm._v("Your search for \""+_vm._s(_vm.search)+"\" found no results.")])],2)],1),_vm._v(" "),_c('v-navigation-drawer',{attrs:{"width":"330","fixed":"","temporary":"","hide-overlay":"","right":"","clipped":""},model:{value:(_vm.drawer),callback:function ($$v) {_vm.drawer=$$v},expression:"drawer"}},[_c('v-list',{staticClass:"pa-1"},[_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Donation Details")])],1)],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('div',{staticClass:"table__overflow"},[_c('table',{staticClass:"v-datatable v-table theme--light"},[_c('tbody',[_c('tr',{staticClass:"contact"},[_c('td',[_vm._v("Contact:")]),_vm._v(" "),_c('td',[_c('b',{staticClass:"name"},[_vm._v(_vm._s(_vm.activeItem.name))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":'mailto:'+_vm.activeItem.email}},[_vm._v(_vm._s(_vm.activeItem.email))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":'tel:'+_vm.activeItem.phone}},[_vm._v(_vm._s(_vm.activeItem.phone))])])]),_vm._v(" "),_c('tr',[_c('td',[_c('span',[_vm._v("UMRN:")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.activeItem.UMRN))])]),_vm._v(" "),_c('tr',[_c('td',[_c('span',[_vm._v("Created:")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(this.formatDate(_vm.activeItem.createdOn)))])]),_vm._v(" "),_c('tr',[_c('td',[_c('span',[_vm._v("Updated:")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.formatDate(_vm.activeItem.updatedOn)))])]),_vm._v(" "),_c('tr',[_c('td',[_c('span',[_vm._v("Last Status:")])]),_vm._v(" "),_c('td',[_c('status',{attrs:{"status":_vm.getLastStatus(_vm.activeItem)}})],1)]),_vm._v(" "),_c('tr',{staticClass:"history"},[_c('td',[_c('span',[_vm._v("History:")])]),_vm._v(" "),_c('td',[_c('history',{attrs:{"history":_vm.activeItem.history,"regId":_vm.activeItem.key},on:{"click":_vm.handleHistoryClick}})],1)]),_vm._v(" "),_c('tr',{staticClass:"loader"},[_c('td',{attrs:{"colspan":"100%"}},[_c('v-progress-linear',{attrs:{"color":"secondary","height":"2","indeterminate":_vm.isLoading}})],1)]),_vm._v(" "),_c('tr',[_c('td',[_c('span',[_vm._v("Actions:")])]),_vm._v(" "),_c('td',[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":"","title":"Delete Scheduler & Record permenantly"},on:{"click":function($event){return _vm.deleteItem(_vm.activeItem)}}},[_c('v-icon',{attrs:{"color":"error"}},[_vm._v("delete")])],1),_vm._v(" "),_c('v-btn',{staticClass:"mx-0",attrs:{"icon":"","disabled":_vm.isLoading,"title":"Tigger Donate for this month"},on:{"click":function($event){return _vm.triggerDonate(_vm.activeItem)}}},[_c('v-icon',{attrs:{"color":"teal"}},[_vm._v("play_circle_filled")])],1)],1)])])])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 335:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProgramsPage_vue__ = __webpack_require__(141);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70da7ab9_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProgramsPage_vue__ = __webpack_require__(337);
function injectStyle (ssrContext) {
  __webpack_require__(336)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProgramsPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70da7ab9_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProgramsPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 336:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 337:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"outer"},[_c('v-dialog',{attrs:{"fullscreen":"","hide-overlay":"","transition":"dialog-bottom-transition"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v(_vm._s(_vm.formTitle))])]),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs6":""}},[_c('v-switch',{attrs:{"label":("Project Active?: " + (_vm.editedItem.active ? 'Yes' : 'No'))},model:{value:(_vm.editedItem.active),callback:function ($$v) {_vm.$set(_vm.editedItem, "active", $$v)},expression:"editedItem.active"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-switch',{attrs:{"label":("Featured Project?: " + (_vm.editedItem.featured ? 'Yes' : 'No'))},model:{value:(_vm.editedItem.featured),callback:function ($$v) {_vm.$set(_vm.editedItem, "featured", $$v)},expression:"editedItem.featured"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md8":""}},[_c('v-text-field',{attrs:{"label":"Title","rules":[_vm.rules.required],"counter":"100","max":"100"},model:{value:(_vm.editedItem.title),callback:function ($$v) {_vm.$set(_vm.editedItem, "title", $$v)},expression:"editedItem.title"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-text-field',{attrs:{"label":"Program ID","rules":[_vm.rules.required],"counter":"20","max":"20","hint":"Used for URL: No special characters, No space","persistent-hint":""},model:{value:(_vm.editedItem.id),callback:function ($$v) {_vm.$set(_vm.editedItem, "id", $$v)},expression:"editedItem.id"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md8":""}},[_c('v-text-field',{attrs:{"label":"Subheading","rules":[_vm.rules.required],"counter":"100","max":"100"},model:{value:(_vm.editedItem.subheading),callback:function ($$v) {_vm.$set(_vm.editedItem, "subheading", $$v)},expression:"editedItem.subheading"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-select',{attrs:{"items":_vm.items,"item-text":"label","item-value":"key","label":"Solution Type"},model:{value:(_vm.editedItem.solutionId),callback:function ($$v) {_vm.$set(_vm.editedItem, "solutionId", $$v)},expression:"editedItem.solutionId"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Introduction","rules":[_vm.rules.required],"counter":"500","max":"500"},model:{value:(_vm.editedItem.intro),callback:function ($$v) {_vm.$set(_vm.editedItem, "intro", $$v)},expression:"editedItem.intro"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('markdown-editor',{attrs:{"configs":_vm.editorConfigs},model:{value:(_vm.editedItem.description),callback:function ($$v) {_vm.$set(_vm.editedItem, "description", $$v)},expression:"editedItem.description"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"GalleryId","hint":"ID is the serial number at the end of the album URL (Eg: https://www.flickr.com/photos/godreams/albums/72157700519436314). Keep the field empty to hide the Gallery section","persistent-hint":""},model:{value:(_vm.editedItem.galleryId),callback:function ($$v) {_vm.$set(_vm.editedItem, "galleryId", $$v)},expression:"editedItem.galleryId"}}),_vm._v(" "),_c('p')],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"accent"},nativeOn:{"click":function($event){return _vm.save($event)}}},[_vm._v("Save")]),_vm._v(" "),_c('v-btn',{attrs:{"color":""},nativeOn:{"click":function($event){return _vm.close($event)}}},[_vm._v("Cancel")])],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-card',{attrs:{"height":"100%"}},[_c('v-card-title',{staticClass:"title"},[_vm._v("Programs\n      "),_c('v-spacer')],1),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.programList,"hide-actions":""},scopedSlots:_vm._u([{key:"items",fn:function(props ){return [_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.id))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.title))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.subheading))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(props.item.active? 'Yes' : 'No'))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(props.item.featured? 'Yes' : 'No'))]),_vm._v(" "),_c('td',{staticClass:"justify-center layout px-0"},[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.editItem(props.item)}}},[_c('v-icon',{attrs:{"color":"info "}},[_vm._v("edit")])],1),_vm._v(" "),_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.deleteItem(props.item)}}},[_c('v-icon',{attrs:{"color":"error "}},[_vm._v("delete")])],1)],1)]}}])},[_vm._v(" "),_c('template',{slot:"no-data "},[_vm._v("Loading Data...")])],2),_vm._v(" "),_c('v-btn',{attrs:{"fab":"","bottom":"","left":"","fixed":"","color":"accent"},on:{"click":function($event){$event.stopPropagation();_vm.dialog=! _vm.dialog}}},[_c('v-icon',[_vm._v("add")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 338:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LocationsPage_vue__ = __webpack_require__(142);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f818f84_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LocationsPage_vue__ = __webpack_require__(340);
function injectStyle (ssrContext) {
  __webpack_require__(339)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LocationsPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f818f84_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LocationsPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 339:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 340:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"outer"},[_c('v-dialog',{attrs:{"fullscreen":"","hkeye-overlay":"","transition":"dialog-bottom-transition"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v(_vm._s(_vm.formTitle))])]),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grkey-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs6":""}},[_c('v-switch',{attrs:{"label":("Location Covered by Guardians?: " + (_vm.editedItem.covered ? 'Yes' : 'No'))},model:{value:(_vm.editedItem.covered),callback:function ($$v) {_vm.$set(_vm.editedItem, "covered", $$v)},expression:"editedItem.covered"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Title","rules":[_vm.rules.required],"counter":"100","max":"100"},model:{value:(_vm.editedItem.title),callback:function ($$v) {_vm.$set(_vm.editedItem, "title", $$v)},expression:"editedItem.title"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Area","rules":[_vm.rules.required],"hint":"Possible values: banglore/chennai/cochin","persistent-hint":""},model:{value:(_vm.editedItem.area),callback:function ($$v) {_vm.$set(_vm.editedItem, "area", $$v)},expression:"editedItem.area"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-text-field',{attrs:{"label":"Lattitude","rules":[_vm.rules.required]},model:{value:(_vm.editedItem.lat),callback:function ($$v) {_vm.$set(_vm.editedItem, "lat", $$v)},expression:"editedItem.lat"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-text-field',{attrs:{"label":"Longitude","rules":[_vm.rules.required]},model:{value:(_vm.editedItem.lng),callback:function ($$v) {_vm.$set(_vm.editedItem, "lng", $$v)},expression:"editedItem.lng"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Order"},model:{value:(_vm.editedItem.order),callback:function ($$v) {_vm.$set(_vm.editedItem, "order", $$v)},expression:"editedItem.order"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"accent"},nativeOn:{"click":function($event){return _vm.save($event)}}},[_vm._v("Save")]),_vm._v(" "),_c('v-btn',{attrs:{"color":""},nativeOn:{"click":function($event){return _vm.close($event)}}},[_vm._v("Cancel")])],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-card',{attrs:{"height":"100%"}},[_c('v-card-title',{staticClass:"title"},[_vm._v("Locations\n      "),_c('v-spacer'),_vm._v(" "),_c('v-text-field',{attrs:{"append-icon":"search","label":"Search","single-line":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.locationList,"search":_vm.search,"rows-per-page-items":[25, 50, 100, 250]},scopedSlots:_vm._u([{key:"items",fn:function(props ){return [_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.title))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.area))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.lat))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.lng))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(props.item.covered? 'Yes' : 'No'))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.order))]),_vm._v(" "),_c('td',{staticClass:"justify-center layout px-0"},[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.editItem(props.item)}}},[_c('v-icon',{attrs:{"color":"info "}},[_vm._v("edit")])],1),_vm._v(" "),_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.deleteItem(props.item)}}},[_c('v-icon',{attrs:{"color":"error "}},[_vm._v("delete")])],1)],1)]}}])},[_vm._v(" "),_c('template',{slot:"no-data "},[_vm._v("Loading Data...")])],2),_vm._v(" "),_c('v-btn',{attrs:{"fab":"","bottom":"","left":"","fixed":"","color":"accent "},on:{"click":function($event){$event.stopPropagation();_vm.dialog=! _vm.dialog}}},[_c('v-icon',[_vm._v("add")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 341:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImpactPage_vue__ = __webpack_require__(143);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b9635594_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ImpactPage_vue__ = __webpack_require__(343);
function injectStyle (ssrContext) {
  __webpack_require__(342)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImpactPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b9635594_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ImpactPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 342:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 343:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-title',{staticClass:"title"},[_vm._v("Impact\n  ")]),_vm._v(" "),_c('v-card-text',[_c('v-container',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_vm._l((_vm.impacts),function(impact,index){return [_c('v-flex',{key:'t' + index,attrs:{"xs8":"","md3":""}},[_c('v-text-field',{attrs:{"label":"Title","rules":[_vm.rules.required]},model:{value:(impact.title),callback:function ($$v) {_vm.$set(impact, "title", $$v)},expression:"impact.title"}})],1),_vm._v(" "),_c('v-flex',{key:'v' + index,attrs:{"xs4":"","md3":""}},[_c('v-text-field',{attrs:{"label":"Value","rules":[_vm.rules.required],"persistent-hint":""},model:{value:(impact.value),callback:function ($$v) {_vm.$set(impact, "value", $$v)},expression:"impact.value"}})],1)]})],2),_vm._v(" "),_c('v-layout',[_c('v-flex',{attrs:{"xs12":""}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"accent"},nativeOn:{"click":function($event){return _vm.save($event)}}},[_vm._v("Save")])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 344:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AboutPage_vue__ = __webpack_require__(144);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06faa09b_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AboutPage_vue__ = __webpack_require__(346);
function injectStyle (ssrContext) {
  __webpack_require__(345)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AboutPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06faa09b_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AboutPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 345:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 346:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"width":"100%"}},[_c('v-card-title',{staticClass:"title"},[_vm._v("\n    About\n  ")]),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('markdown-editor',{attrs:{"configs":_vm.editorConfigs},model:{value:(_vm.about),callback:function ($$v) {_vm.about=$$v},expression:"about"}})],1)],1),_vm._v(" "),_c('v-layout',[_c('v-flex',{attrs:{"xs12":""}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"accent"},nativeOn:{"click":function($event){return _vm.save($event)}}},[_vm._v("Save")])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 347:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CareersPage_vue__ = __webpack_require__(145);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_362646e8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CareersPage_vue__ = __webpack_require__(349);
function injectStyle (ssrContext) {
  __webpack_require__(348)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CareersPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_362646e8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CareersPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 348:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 349:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"outer"},[_c('v-dialog',{attrs:{"fullscreen":"","hide-overlay":"","transition":"dialog-bottom-transition"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v(_vm._s(_vm.formTitle))])]),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs6":""}},[_c('v-switch',{attrs:{"label":("Listing Active?: " + (_vm.editedItem.active ? 'Yes' : 'No'))},model:{value:(_vm.editedItem.active),callback:function ($$v) {_vm.$set(_vm.editedItem, "active", $$v)},expression:"editedItem.active"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-select',{attrs:{"items":_vm.types,"item-text":"label","item-value":"key","label":"Commitment Type"},model:{value:(_vm.editedItem.type),callback:function ($$v) {_vm.$set(_vm.editedItem, "type", $$v)},expression:"editedItem.type"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md8":""}},[_c('v-text-field',{attrs:{"label":"Title","rules":[_vm.rules.required],"counter":"100","max":"100"},model:{value:(_vm.editedItem.title),callback:function ($$v) {_vm.$set(_vm.editedItem, "title", $$v)},expression:"editedItem.title"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-text-field',{attrs:{"label":"Career ID / URL","rules":[_vm.rules.required],"counter":"20","max":"20","hint":"Used for URL: No special characters, No space. Hiphen (-) instead of space","persistent-hint":""},model:{value:(_vm.editedItem.id),callback:function ($$v) {_vm.$set(_vm.editedItem, "id", $$v)},expression:"editedItem.id"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Role","rules":[_vm.rules.required],"counter":"100","max":"100"},model:{value:(_vm.editedItem.role),callback:function ($$v) {_vm.$set(_vm.editedItem, "role", $$v)},expression:"editedItem.role"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('markdown-editor',{attrs:{"configs":_vm.editorConfigs},model:{value:(_vm.editedItem.details),callback:function ($$v) {_vm.$set(_vm.editedItem, "details", $$v)},expression:"editedItem.details"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"accent "},nativeOn:{"click":function($event){return _vm.save($event)}}},[_vm._v("Save")]),_vm._v(" "),_c('v-btn',{attrs:{"color":" "},nativeOn:{"click":function($event){return _vm.close($event)}}},[_vm._v("Cancel")])],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-card',{attrs:{"height":"100%"}},[_c('v-card-title',{staticClass:"title"},[_vm._v("Careers\n      "),_c('v-spacer')],1),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.careerList,"hide-actions":""},scopedSlots:_vm._u([{key:"items",fn:function(props ){return [_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.title))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.role))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.type === 'job' ? 'Paid Job' : 'Volunteering'))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(props.item.active? 'Yes' : 'No'))]),_vm._v(" "),_c('td',{staticClass:"justify-center layout px-0"},[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.editItem(props.item)}}},[_c('v-icon',{attrs:{"color":"info "}},[_vm._v("edit")])],1),_vm._v(" "),_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.deleteItem(props.item)}}},[_c('v-icon',{attrs:{"color":"error "}},[_vm._v("delete")])],1)],1)]}}])},[_vm._v(" "),_c('template',{slot:"no-data "},[_vm._v("Loading Data...")])],2),_vm._v(" "),_c('v-btn',{attrs:{"fab":"","bottom":"","left":"","fixed":"","color":"accent "},on:{"click":function($event){$event.stopPropagation();_vm.dialog=! _vm.dialog}}},[_c('v-icon',[_vm._v("add")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 350:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SignInPage_vue__ = __webpack_require__(146);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e250bc2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SignInPage_vue__ = __webpack_require__(351);
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SignInPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e250bc2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SignInPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 351:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',{attrs:{"xs12":"","sm8":"","lg6":""}},[_c('v-card',{staticClass:"pa-4"},[_c('div',[_c('h3',{staticClass:"headline mb-0"},[_vm._v("Sign In")]),_vm._v(" "),_c('div',[_vm._v("Please enter your registered Email & Password")])]),_vm._v(" "),_c('v-form',{ref:"form",staticClass:"mt-5",model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-text-field',{attrs:{"required":"","clearable":"","rules":_vm.emailRules,"label":"E-mail","autocomplete":"current-password"},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}}),_vm._v(" "),_c('v-text-field',{attrs:{"required":"","clearable":"","rules":_vm.passwordRules,"label":"Password","type":"password","autocomplete":"current-password"},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}}),_vm._v(" "),_c('v-btn',{attrs:{"disabled":!_vm.valid,"color":"accent"},on:{"click":_vm.submit}},[_vm._v("Sign In")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 352:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(147);


/* harmony default export */ __webpack_exports__["a"] = (function (to, from, next) {
  if (__WEBPACK_IMPORTED_MODULE_0__store__["a" /* store */].getters.user !== null) {
    console.log('Authorised!');
    next();
  } else {
    console.log('Unauthorised!!!!');
    next('/signin/');
  }
});

/***/ }),

/***/ 426:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_app__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase_auth__ = __webpack_require__(427);




var state = {
  user: null
};

var getters = {
  user: function user(state) {
    return state.user;
  }
};

// Career section
var mutations = {
  signout: function signout(state, payload) {
    state.user = null;
  },
  signin: function signin(state, payload) {
    state.user = payload;
  }
};

// Career section

var actions = {
  signout: function signout(_ref) {
    var commit = _ref.commit;

    __WEBPACK_IMPORTED_MODULE_1_firebase_app___default.a.auth().signOut().then(function () {
      // Sign-out successful.
      commit('signout', null);
    }).catch(function (error) {
      // An error happened.
    });
  },
  signin: function signin(_ref2, payload) {
    var commit = _ref2.commit,
        dispatch = _ref2.dispatch;

    __WEBPACK_IMPORTED_MODULE_1_firebase_app___default.a.auth().signInWithEmailAndPassword(payload.email, payload.password).then(function (user) {
      commit('showMessage', {
        type: 'info',
        message: 'Signed in, Welcome!'
      });

      commit('signin', user);
      dispatch('load');
    }).catch(function (error) {
      if (error) {
        commit('showMessage', {
          type: 'error',
          message: 'Error: Login failed, please try again!'
        });
        console.log(error);
      }
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({ state: state, getters: getters, actions: actions, mutations: mutations });

/***/ }),

/***/ 429:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_app__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase_database__ = __webpack_require__(21);






var state = {
  programs: {}
};

var getters = {
  programList: function programList(state) {
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(state.programs);
  }
};

// Program section
var mutations = {
  loadPrograms: function loadPrograms(state, payload) {
    state.programs = payload;
  },
  saveProgram: function saveProgram(state, payload) {
    __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(state.programs, payload.key, payload);
  },
  deleteProgram: function deleteProgram(state, payload) {
    __WEBPACK_IMPORTED_MODULE_2_vue__["default"].delete(state.programs, payload.key);
  }
};

var actions = {
  // Program section
  addProgram: function addProgram(_ref, payload) {
    var commit = _ref.commit;

    var programsRef = __WEBPACK_IMPORTED_MODULE_3_firebase_app___default.a.database().ref('content/programs/');
    var newPostRef = programsRef.push();
    var updatedPayload = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
      key: newPostRef.key
    }, payload);

    newPostRef.set(updatedPayload, function (error) {
      if (error) {
        // The write failed...
        commit('showMessage', {
          type: 'error',
          message: 'Error saving New Program, Try again!'
        });
      } else {
        // Data saved successfully!
        commit('showMessage', { message: 'New Program saved successfully!' });
        commit('saveProgram', updatedPayload);
      }
    });
  },
  saveProgram: function saveProgram(_ref2, payload) {
    var commit = _ref2.commit;

    __WEBPACK_IMPORTED_MODULE_3_firebase_app___default.a.database().ref('content/programs/' + payload.key).set(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, payload), function (error) {
      if (error) {
        // The write failed...
        commit('showMessage', {
          type: 'error',
          message: 'Error saving New Program, Try again!'
        });
        console.log(error);
      } else {
        commit('showMessage', { message: 'Program saved successfully!' });
        commit('saveProgram', payload);
      }
    });
  },
  deleteProgram: function deleteProgram(_ref3, payload) {
    var commit = _ref3.commit;

    __WEBPACK_IMPORTED_MODULE_3_firebase_app___default.a.database().ref('content/programs/' + payload.key).set(null, function (error) {
      if (error) {
        // The write failed...
        commit('showMessage', {
          type: 'error',
          message: 'Error deleting Program, Try again!'
        });
        console.log(error);
      } else {
        commit('showMessage', { message: 'Program deleted successfully!' });
        commit('deleteProgram', payload);
      }
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({ state: state, getters: getters, actions: actions, mutations: mutations });

/***/ }),

/***/ 430:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase_app__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_database__ = __webpack_require__(21);





var state = {
  donations: {}
};

var getters = {
  donationList: function donationList(state) {
    return function (filter) {
      if (filter !== "none") {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(state.donations).filter(function (donation) {
          return donation.status === filter;
        });
      }
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(state.donations);
    };
  }
};

// Donation section
var mutations = {
  loadDonations: function loadDonations(state, payload) {
    state.donations = payload;
  },
  deleteDonation: function deleteDonation(state, payload) {
    __WEBPACK_IMPORTED_MODULE_1_vue__["default"].delete(state.donations, payload.key);
  }
};

var actions = {
  deleteDonation: function deleteDonation(_ref, payload) {
    var commit = _ref.commit;

    __WEBPACK_IMPORTED_MODULE_2_firebase_app___default.a.database().ref("data/donations/" + payload.key).set(null, function (error) {
      if (error) {
        // The write failed...
        commit("showMessage", {
          type: "error",
          message: "Error deleting Donation, Try again!"
        });
        console.log(error);
      } else {
        commit("showMessage", { message: "Donation deleted successfully!" });
        commit("deleteDonation", payload);
      }
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({ state: state, getters: getters, actions: actions, mutations: mutations });

/***/ }),

/***/ 431:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_app__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase_database__ = __webpack_require__(21);






var state = {
  locations: {}
};

var getters = {
  locationList: function locationList(state) {
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(state.locations);
  }
};

// Location section
var mutations = {
  loadLocations: function loadLocations(state, payload) {
    state.locations = payload;
  },
  saveLocation: function saveLocation(state, payload) {
    __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(state.locations, payload.key, payload);
  },
  deleteLocation: function deleteLocation(state, payload) {
    __WEBPACK_IMPORTED_MODULE_2_vue__["default"].delete(state.locations, payload.key);
  }
};

var actions = {
  // Location section
  addLocation: function addLocation(_ref, payload) {
    var commit = _ref.commit;

    var locationsRef = __WEBPACK_IMPORTED_MODULE_3_firebase_app___default.a.database().ref('content/locations/');
    var newPostRef = locationsRef.push();
    var updatedPayload = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, payload, {
      key: newPostRef.key
    });

    newPostRef.set(updatedPayload, function (error) {
      if (error) {
        // The write failed...
        commit('showMessage', {
          type: 'error',
          message: 'Error saving New Location, Try again!'
        });
      } else {
        // Data saved successfully!
        commit('showMessage', { message: 'New Location saved successfully!' });
        commit('saveLocation', updatedPayload);
      }
    });
  },
  saveLocation: function saveLocation(_ref2, payload) {
    var commit = _ref2.commit;

    __WEBPACK_IMPORTED_MODULE_3_firebase_app___default.a.database().ref('content/locations/' + payload.key).set(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, payload), function (error) {
      if (error) {
        // The write failed...
        commit('showMessage', {
          type: 'error',
          message: 'Error saving New Location, Try again!'
        });
        console.log(error);
      } else {
        commit('showMessage', { message: 'Location saved successfully!' });
        commit('saveLocation', payload);
      }
    });
  },
  deleteLocation: function deleteLocation(_ref3, payload) {
    var commit = _ref3.commit;

    __WEBPACK_IMPORTED_MODULE_3_firebase_app___default.a.database().ref('content/locations/' + payload.key).set(null, function (error) {
      if (error) {
        // The write failed...
        commit('showMessage', {
          type: 'error',
          message: 'Error deleting Location, Try again!'
        });
        console.log(error);
      } else {
        commit('showMessage', { message: 'Location deleted successfully!' });
        commit('deleteLocation', payload);
      }
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({ state: state, getters: getters, actions: actions, mutations: mutations });

/***/ }),

/***/ 432:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_app__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase_database__ = __webpack_require__(21);




var state = {
  impact: {}
};

var getters = {
  impactList: function impactList(state) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(state.impact);
  }
};

var mutations = {
  loadImpact: function loadImpact(state, payload) {
    state.impact = payload;
  },
  saveImpact: function saveImpact(state, payload) {
    state.impact = payload;
  }
};

var actions = {
  saveImpact: function saveImpact(_ref, payload) {
    var commit = _ref.commit;

    __WEBPACK_IMPORTED_MODULE_1_firebase_app___default.a.database().ref('content/impact/').set(payload, function (error) {
      if (error) {
        // The write failed...
        commit('showMessage', {
          type: 'error',
          message: 'Error saving Impact, Try again!'
        });
        console.log(error);
      } else {
        commit('showMessage', { message: 'Impact saved successfully!' });
        commit('saveImpact', payload);
      }
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({ state: state, getters: getters, actions: actions, mutations: mutations });

/***/ }),

/***/ 433:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase_app__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_database__ = __webpack_require__(21);



var state = {
  about: ""
};

var getters = {
  about: function about(state) {
    return state.about;
  }
};

var mutations = {
  loadAbout: function loadAbout(state, payload) {
    state.about = payload;
  },
  saveAbout: function saveAbout(state, payload) {
    state.about = payload;
  }
};

var actions = {
  saveAbout: function saveAbout(_ref, payload) {
    var commit = _ref.commit;

    __WEBPACK_IMPORTED_MODULE_0_firebase_app___default.a.database().ref('content/about/').set(payload, function (error) {
      if (error) {
        // The write failed...
        commit('showMessage', {
          type: 'error',
          message: 'Error saving About, Try again!'
        });
        console.log(error);
      } else {
        commit('showMessage', { message: 'About saved successfully!' });
        commit('saveAbout', payload);
      }
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({ state: state, getters: getters, actions: actions, mutations: mutations });

/***/ }),

/***/ 434:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_app__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase_database__ = __webpack_require__(21);






var state = {
  careers: {}
};

var getters = {
  careerList: function careerList(state) {
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(state.careers);
  }
};

// Career section
var mutations = {
  loadCareers: function loadCareers(state, payload) {
    state.careers = payload;
  },
  saveCareer: function saveCareer(state, payload) {
    __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(state.careers, payload.key, payload);
  },
  deleteCareer: function deleteCareer(state, payload) {
    __WEBPACK_IMPORTED_MODULE_2_vue__["default"].delete(state.careers, payload.key);
  }
};

// Career section

var actions = {
  addCareer: function addCareer(_ref, payload) {
    var commit = _ref.commit;

    var careersRef = __WEBPACK_IMPORTED_MODULE_3_firebase_app___default.a.database().ref('content/careers/');
    var newPostRef = careersRef.push();
    var updatedPayload = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
      key: newPostRef.key
    }, payload);

    newPostRef.set(updatedPayload, function (error) {
      if (error) {
        // The write failed...
        commit('showMessage', {
          type: 'error',
          message: 'Error saving New Career, Try again!'
        });
      } else {
        // Data saved successfully!
        commit('showMessage', { message: 'New Career saved successfully!' });
        commit('saveCareer', updatedPayload);
      }
    });
  },
  saveCareer: function saveCareer(_ref2, payload) {
    var commit = _ref2.commit;

    __WEBPACK_IMPORTED_MODULE_3_firebase_app___default.a.database().ref('content/careers/' + payload.key).set(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, payload), function (error) {
      if (error) {
        // The write failed...
        commit('showMessage', {
          type: 'error',
          message: 'Error saving New Career, Try again!'
        });
        console.log(error);
      } else {
        commit('showMessage', { message: 'Career saved successfully!' });
        commit('saveCareer', payload);
      }
    });
  },
  deleteCareer: function deleteCareer(_ref3, payload) {
    var commit = _ref3.commit;

    __WEBPACK_IMPORTED_MODULE_3_firebase_app___default.a.database().ref('content/careers/' + payload.key).set(null, function (error) {
      if (error) {
        // The write failed...
        commit('showMessage', {
          type: 'error',
          message: 'Error deleting Career, Try again!'
        });
        console.log(error);
      } else {
        commit('showMessage', { message: 'Career deleted successfully!' });
        commit('deleteCareer', payload);
      }
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({ state: state, getters: getters, actions: actions, mutations: mutations });

/***/ }),

/***/ 436:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 452:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 454:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 86:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_sections_list__ = __webpack_require__(87);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: { sectionsList: __WEBPACK_IMPORTED_MODULE_0__components_sections_list__["a" /* default */] },
  data: function data() {
    return {
      mini: false,
      dialog: false,
      drawer: null,
      showLinks: false
    };
  },

  computed: {
    status: function status() {
      return this.$store.getters.status;
    },
    isLogged: function isLogged() {
      return this.$store.getters.user ? true : false;
    }
  },

  methods: {
    handleRoute: function handleRoute(route) {
      // this.$router.push(route);
    },
    handleSignout: function handleSignout() {
      this.$store.dispatch("signout");
      this.$router.push("/signin");
    }
  }
});

/***/ }),

/***/ 87:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sections_list_vue__ = __webpack_require__(88);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58946b4a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sections_list_vue__ = __webpack_require__(170);
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sections_list_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58946b4a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sections_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 88:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      items: [{ icon: "credit_card", text: "Donations", route: "/donations" }, { icon: "list_alt", text: "Programs", route: "/programs" }, { icon: "room", text: "Locations", route: "/locations" }, { icon: "trending_up", text: "Impact", route: "/impact" }, { icon: "work", text: "Careers", route: "/careers" }, { icon: "assignment", text: "About", route: "/about"
        // { icon: "view_quilt", text: "Dashboard", route: "/" },
        // { icon: "contacts", text: "Volunteers", route: "/volunteers" },
        // { icon: "settings", text: "Settings", route: "/settings" },
        // { icon: "chat_bubble", text: "Message", route: "/message" }
      }]
    };
  }
});

/***/ }),

/***/ 89:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_sections_list__ = __webpack_require__(87);
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: { sectionsList: __WEBPACK_IMPORTED_MODULE_0__components_sections_list__["a" /* default */] },
  mounted: function mounted() {
    //fetch data from DB
  }
});

/***/ }),

/***/ 90:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_status__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_history__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_date_fns__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_date_fns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_date_fns__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_lib__ = __webpack_require__(105);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  components: { status: __WEBPACK_IMPORTED_MODULE_3__components_status__["a" /* default */], history: __WEBPACK_IMPORTED_MODULE_4__components_history__["a" /* default */] },
  data: function data() {
    return {
      statusList: ["none", "success", "failed", "initiated", "triggered"],
      selectedStatus: "none",
      search: "",
      drawer: false,
      pagination: {
        sortBy: "key",
        descending: true
      },
      headers: [{
        text: "DonorID",
        value: "donorId"
      }, {
        text: "UMRN",
        value: "UMRN"
      }, {
        text: "Name",
        value: "name"
      },
      // {
      //   text: "Email",
      //   value: "email"
      // },
      // {
      //   text: "Phone",
      //   value: "phone"
      // },

      {
        text: "Start",
        value: "dateStart"
      }, {
        text: "End",
        value: "dateEnd"
      }, {
        text: "Slot",
        value: "slot",
        align: "center"
      }, {
        text: "Amount",
        value: "amount",
        align: "right"
      }, {
        text: "Status",
        value: "stage",
        align: "right"
      }],
      isLoading: false,
      activeIndex: 0
    };
  },

  computed: {
    donationList: function donationList() {
      return this.$store.getters.donationList(this.selectedStatus);
    },
    activeItem: function activeItem() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.donationList[this.activeIndex]);
    }
  },

  watch: {
    dialog: function dialog(val) {
      val || this.close();
    }
  },

  methods: {
    formatDate: function formatDate(timestamp) {
      return timestamp ? new Date(timestamp).toString().substring(4, 24) : "-";
    },
    formatDateDDMMYYY: function formatDateDDMMYYY(date) {
      return date.replace(/-/g, "");
    },
    msg: function msg(item) {
      return Object(__WEBPACK_IMPORTED_MODULE_7__assets_lib__["a" /* monthFromDate */])(this.getLastMonth(item));
    },
    getLastHistory: function getLastHistory(history) {
      var entries = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(history);

      entries.sort(function (a, b) {
        var dateA = Object(__WEBPACK_IMPORTED_MODULE_7__assets_lib__["b" /* toDefaultDate */])(a.dateTime);
        var dateB = Object(__WEBPACK_IMPORTED_MODULE_7__assets_lib__["b" /* toDefaultDate */])(b.dateTime);
        return dateA - dateB;
      });
      return entries.pop();
    },
    getLastStatus: function getLastStatus(item) {
      if (item.history) {
        return this.getLastHistory(item.history).status || "";
      }
      return item.status;
    },
    getLastMonth: function getLastMonth(item) {
      if (item.history) {
        return this.getLastHistory(item.history).dateTime || "";
      }
      return "";
    },
    setActiveItem: function setActiveItem(item) {
      this.activeIndex = this.donationList.indexOf(item);
      this.drawer = true;
    },
    deleteItem: function deleteItem(item) {
      if (confirm("Are you sure you want to delete this record? \nNote: This will cancel all future Monthly donations permenantly!")) {
        this.$store.dispatch("deleteDonation", item);
        this.drawer = false;
      }
    },
    setLoading: function setLoading() {
      var status = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      if (!status) {
        this.isLoading = false;
      } else {
        this.isLoading = true;
        this.activeItem.info = "Loading...";
      }
    },
    triggerDonate: function triggerDonate(item) {
      var _this = this;

      if (!confirm("Are you sure you want to Trigger this donation? \nNote: This will initiate the money transfer from the Doner!")) {
        return;
      }

      this.setLoading();

      var key = item.key;
      var UMRN = item.UMRN;
      var amount = item.amount;

      var URL = "https://us-central1-guardians-of-dreams.cloudfunctions.net/triggerMonthlyDonationAPI";

      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(URL, {
        crossdomain: true,
        params: { key: key, UMRN: UMRN, amount: amount }
      }).then(function (response) {
        _this.setLoading(false);
        console.log(response);
      }).catch(function (error) {
        _this.setLoading(false);
        console.log(error);
      });
    },
    triggerAllDonate: function triggerAllDonate(item) {
      this.setLoading();

      var URL = "https://us-central1-guardians-of-dreams.cloudfunctions.net/triggerAllMonthlyDonationsAPI";

      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(URL, {
        crossdomain: true,
        params: {}
      }).then(function (response) {
        console.log("triggerAllDonate::", response);
      }).catch(function (error) {
        console.log("triggerAllDonate::", error);
      });
    },
    varifyTransaction: function varifyTransaction(_ref) {
      var _this2 = this;

      var key = _ref.key,
          trnId = _ref.trnId,
          dateTime = _ref.dateTime;

      this.setLoading();

      var URL = "https://us-central1-guardians-of-dreams.cloudfunctions.net/transactionVarificationAPI";

      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(URL, {
        crossdomain: true,
        params: { key: key, trnId: trnId, dateTime: dateTime }
      }).then(function (response) {
        _this2.setLoading(false);
        console.log(response);
      }).catch(function (error) {
        _this2.setLoading(false);
        console.log(error);
      });
    },
    handleHistoryClick: function handleHistoryClick(key, trnId, dateTime) {
      this.varifyTransaction({ key: key, trnId: trnId, dateTime: dateTime });
    }
  }
});

/***/ })

},[165]);


// WEBPACK FOOTER //
// static/js/app.3f63d06ef05e0c932a18.js